import React, {Component} from "react";
import "../../VisitHistory.css";
import CurrentPreviousEnum from "../../../subjective/enums/complaint/CurrentPreviousEnum";
import DurationEnum from "../../../subjective/enums/complaint/DurationEnum";
import DateUtil from "../../../../../../utils/DateUtil";
import RedFlagEnum from "../../../subjective/enums/complaint/RedFlagEnum";
import EtiologyEnum from "../../../subjective/enums/complaint/EtiologyEnum";
import NatureEnum from "../../../subjective/enums/complaint/NatureEnum";
import StringUtil from "../../../../../../utils/StringUtil";

export default class SymptomViewHistory extends Component {
    render() {
        if (this.props.complaint == null || this.checkSymptomDataAvailability(this.props.complaint)) {
            return <div className="pl-3">No information available</div>;
        }

        let [symptomsCol1, symptomsCol2, symptomsCol3] = this.getSymptoms();

        return (
            <div className={"visit-history-symptoms-wrapper pl-3"}>
                <div className={"d-block"}>
                    {symptomsCol1}
                </div>
                <div className={"d-block"}>
                    {symptomsCol2}
                </div>
                <div className={"d-block"}>
                    {symptomsCol3}
                </div>
            </div>
        );
    }

    getSymptomHistoryViewDiv(label, value) {
        return (
            <>
                <span> <b>{label}: </b> {value} </span>
            </>
        );
    }

    getSymptoms() {
        let col1 = [];
        let col2 = [];
        let col3 = [];
        let complaint = this.props.complaint;
        
        // Complaint
        col1.push(this.getSymptomHistoryViewDiv("Complaint", complaint.complaint || "NA"));
        
        // Current/Previous
        (complaint.currentPrevious == null || complaint.currentPrevious === " ") 
            ? col1.push(this.getSymptomHistoryViewDiv("Episode", "NA"))
            : col1.push(this.getSymptomHistoryViewDiv("Episode", CurrentPreviousEnum[complaint.currentPrevious]?.name));

        // Etiology
        if (complaint.etiology.length > 0
            || complaint.etiologyDetail != null
            || complaint.historyOfTrauma != null) {
            let etiologyText = "";
            if (complaint.historyOfTrauma != null) {
                let historyOfTraumaText = complaint.historyOfTrauma ? "Yes" : "No";
                etiologyText += `History of Trauma (${historyOfTraumaText})`;
            }

            const enumDetail = this.enumString(EtiologyEnum,
                complaint.etiology,
                complaint.etiologyDetail);
            if (enumDetail != 'NA') {
                if (StringUtil.isNullOrEmpty(etiologyText)) {
                    etiologyText = enumDetail;
                } else {
                    etiologyText += ", " + enumDetail;
                }
            }

            col2.push(this.getSymptomHistoryViewDiv("Etiology", etiologyText));
        } else {
            col2.push(this.getSymptomHistoryViewDiv("Etiology", "NA"));
        }

        // Red Flags
        if(complaint.redFlagNormal){
            col3.push(this.getSymptomHistoryViewDiv("Red Flags", "No Red Flags"));
        } else if (complaint.redFlag.length > 0
            || (complaint.redFlagDetail != null
                && complaint.redFlagDetail !== "")) {

            col3.push(this.getSymptomHistoryViewDiv("Red Flags",
                this.enumString(RedFlagEnum, complaint.redFlag, complaint.redFlagDetail)));
        } else {
            col3.push(this.getSymptomHistoryViewDiv("Red Flags", "NA"));
        }

        return [col1, col2, col3];
    }

    //TODO: Copied from ComplaintView.js. Find out how to re-use??
    enumString(_class, enumObject, detail) {
        if (enumObject == null || enumObject.length === 0) {
            return (detail && detail !== null) ? detail : 'NA';
        }
        let res = enumObject.map(e => _class[e].name);
        if (detail && detail !== null && detail !== '') {
            res.push(detail);
        }
        return res.join(', ');
    }

    checkSymptomDataAvailability (symptomData) {
        return symptomData.complaint == null
            && symptomData.currentPrevious == null
            && symptomData.etiology.length === 0 && symptomData.etiologyDetail == null && symptomData.historyOfTrauma == null
            && symptomData.redFlag.length === 0 && symptomData.redFlagDetail == null;
    }
}